<template>
  <div>
    <div class="search_banner"></div>
    <div class="clearfix">
      <div class="container_box search_box">
        <div class="fl input_box">
          <div class="search_icon fl" @click="searchSubmit" style="cursor: pointer;">
            <i class="el-icon-search"></i>
          </div>
          <input class="fl" type="text" v-model="formData.searchKey">
        </div>
        <a class="fr btn_box lang_serach"  @click="searchSubmit" style="cursor: pointer;">{{$t('index.serach')}}</a>
      </div>
    </div>
    <div class="container-fixed container_full">
      <div class="search_main_box bg_white mgt10 mgb20">
        <div class="nothing" v-if="searchList==''">
            <img src="../assets/images/nothing.png" alt="">
            <div>{{$t('index.null4')}}</div>
        </div>
        <div class="content_article3">
          <div class="item row row_law" v-for="item in searchList">
              <a v-if="item.type ==0" @click="toRecruit(item.id)" class="col-md-10 col-xs-10 title search_title">
                <!-- {{item.title}} -->
                <v-clamp :max-lines="1">{{item.title}}</v-clamp>
                <span class="label" >招聘信息</span> 
              </a>
              <a v-if=" item.type == 1" @click="toTech(item.id)" class="col-md-10 col-xs-10 title search_title">
                {{item.title}}
                <span class="label" >业务需求</span> 
              </a>
              <a v-if="item.type == 2" @click="toTech(item.id)" class="col-md-10 col-xs-10 title search_title">
                {{item.title}}
                <span class="label" >业务供给</span> 
              </a>
              <a v-if="item.type ==3" @click="toNewsDetail(item.id)"  class="col-md-10 col-xs-10 title search_title">
                <!-- {{item.title}} -->
                <v-clamp :max-lines="1">{{item.title}}</v-clamp>
                <span class="label" >新闻资讯</span>
              </a>           
              <div class="col-md-2 col-xs-2 time media_display" style="text-align: right">{{item.createTime}}</div>
          </div>
        </div>
      </div>
      <div class="page_box" v-show="total>0">
        <el-pagination
          :small="isMobile?true:false"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="formData.limit"
          :total="total">
        </el-pagination>
      </div>
    </div>
    
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
  data() {
    return {
      searchTypeShow: false,
      searchType: '全部',       
      searchTypeList: [
        {
          name: '全部'
        },
        {
          name: '招聘信息'
        },
        {
          name: '业务需求'
        },
        {
          name: '业务供给'
        },
        {
          name: '新闻资讯'
        }
      ],
      bannerList:[],
      searchList:[],
      searchDetail:'',//搜索输入内容
      formData:{
        searchKey:'',
        type:'',
        offset:0,
        limit:10
      },
      currentPage:1,
      totalNum:'', 
      total: 0,   
      isMobile:0,
    };
  },
  methods: {
    openSearchType() {
      this.searchTypeShow = !this.searchTypeShow
    },
    chooseSearchType(index) {
      if (index == 0) {
        this.searchType = '全部';
        this.formData.type  = '';
      }else if (index == 1) {
        this.searchType = '招聘信息';
        this.formData.type  = 0;
      }
      else if (index == 2) {
        this.searchType = '业务需求';
        this.formData.type  = 1;
      }else if (index == 3) {
        this.searchType = '业务供给';
        this.formData.type  = 2;
      }else if (index == 4) {
        this.searchType = '新闻资讯';
        this.formData.type  = 3;
      }
        this.searchTypeShow = false;
    },
    //获取首页轮播图
    getInitSwiper1:function(){
      this.$http.get(this, "/indexbanner/list", {'offset':0,'limit':10,'searchKey':''}).then(res => {
          if (res) {  
            this.bannerList = res.data.rows;         
            //$nextTick(),当Vue构造器里的data值被修改完成后会调用这个方法，也相当于一个钩子函数
            this.$nextTick(function() {
              this.initSwiper1();
            });
          }
      });
    },
    //企业招聘详情
    toRecruit(id){
      console.log('跳转到招聘');
      // this.$router.push({path:'/trade/supply-demand-detail',query:{id:id}}) 
      let routeUrl = this.$router.resolve({
        path: "/trade/enter-recruit-detail",
        query: {id:id}
      });
      window.open(routeUrl.href, '_blank');
    },
    toTech(id){
      console.log('跳转到业务详情');
      let routeUrl = this.$router.resolve({
        path: "/trade/supply-demand-detail",
        query: {id:id,degree:1}
      });
      window.open(routeUrl.href, '_blank');
    },
    toNewsDetail(id){
      this.$router.push({path:'/news-info/detail',query:{id:id}}); 
    },
    //检索
    getSearch(){          
      // this.formData.offset = (this.currentPage - 1) * this.formData.limit;  
      // if(sessionStorage.getItem('homesearchDetail')!=null){
      //   this.searchDetail  = sessionStorage.getItem('homesearchDetail');
      //   this.formData.searchKey = this.searchDetail;
      //   this.formData.type = sessionStorage.getItem('homesearchKey')              
      // }else{
      //   this.formData.searchKey = this.searchDetail;           
      // } 
      // sessionStorage.removeItem('homesearchDetail'); 
      // sessionStorage.removeItem('homesearchKey'); 
      if(this.formData.searchKey==''){
        return
      }
      console.log(this.formData);
      this.formData.offset = (this.currentPage - 1) * this.formData.limit;
      this.$http.get(this, "/noAuth/search", this.formData).then(res => {
          if (res) {  
            this.searchList = res.data.rows; 
            this.total = res.data.total;
          }
      });
    },  
    initSwiper1(){
      // 首页轮播图
      var mySwiper1 = new Swiper('.home_banner .swiper-container', {
        loop: true,
        autoplay: 3000,
        // 如果需要分页器
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplayDisableOnInteraction : false,
      })
    },   
    handleCurrentChange(val){
      this.currentPage = val;
      this.getSearch();
    },
    searchSubmit(){
      this.currentPage = 1;
      this.getSearch();
    }
  },

  created() {
    // this.getInitSwiper1();
    // if(sessionStorage.getItem('homesearchDetail')!=null) {
    //   if(sessionStorage.getItem('homesearchKey') == ''){
    //     this.searchType = '全部';
    //   }else if(sessionStorage.getItem('homesearchKey') == 0 ){
    //     this.searchType = '招聘信息';
    //   }else if(sessionStorage.getItem('homesearchKey') == 1){
    //     this.searchType = '业务需求';
    //   }else if(sessionStorage.getItem('homesearchKey') == 2){
    //     this.searchType = '业务供给';
    //   }else if(sessionStorage.getItem('homesearchKey') == 3){
    //     this.searchType = '新闻资讯';
    //   }
      // this.getSearch();
    // } 
    this.isMobile = Number(localStorage.getItem("isMobile"));
  },
};
</script>
<style lang="less">
.red {
  color: #f00;
}
</style>



// WEBPACK FOOTER //
// src/pages/search.vue